import { createAction } from 'redux-actions'
import axios from 'axios'
import parseDomain from 'parse-domain'

import { garageSetData } from '../garage/actions'
import config from '../../config'

export const appInitError = createAction('APP:APPINITERROR')
export const appInitSuccess = createAction('APP:APPINITSUCCESS')
export const appSetDomain = createAction('APP:APPSETDOMAIN')
export const appSetPDV = createAction('APP:APPSETPDV')

const getDomain = () => {
  const url = window.location.hostname
  const domain = parseDomain(url, {
    customTlds: /localhost|\.local/
  }).subdomain.split('.')[0]

  if (!domain) throw new Error('Subdomain is missing')
  return domain.toUpperCase()
}

const getPDVID = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const pdvID = urlParams.get('pdv')
  return pdvID
}

const computeURL = (domain, pdvID) => {
  const baseUrl = `${config.apiUrl}conf/appuntamenti-web?domain=${domain}`
  if (pdvID === null) return baseUrl
  return `${baseUrl}&pdv=${pdvID}`
}

export const initApp = () => async dispatch => {
  try {
    const domain = getDomain()
    const pdvID = getPDVID()
    dispatch(appSetPDV(pdvID))
    dispatch(appSetDomain(domain))

    const result = await axios.get(computeURL(domain, pdvID))
    dispatch(garageSetData(result.data))
    dispatch(appInitSuccess())
  } catch (e) {
    dispatch(appInitError(e))
  }
}
